// tabs start
document.addEventListener("DOMContentLoaded", () => {
  const overviewSections = document.querySelectorAll(".tabs-container");
  overviewSections.forEach(section => {
    const tabButtons = section.querySelectorAll(".tab-link");
    const contents = section.querySelectorAll(".tab-content");
    tabButtons[0]?.classList.add("active");
    contents[0]?.classList.add("active");
    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-target");
        tabButtons.forEach(btn => btn.classList.remove("active"));
        contents.forEach(content => content.classList.remove("active"));
        button.classList.add("active");
        const targetContent = section.querySelector(`#${target}`);
        if (targetContent) targetContent.classList.add("active");
      });
    });
  });
});

// acccordion start
(function Accordion() {
    const triggers = document.querySelectorAll('[data-toggle="collapse"]');
    let activeToggle;
    triggers.forEach(trigger => {
        trigger.collapseTarget = document.querySelector(trigger.dataset.target);
        if (trigger.collapseTarget.classList.contains("is-active")) {
            activeToggle = trigger;
        }

        trigger.addEventListener("click", event => {
            event.preventDefault();
            toggle(trigger);
        });
        trigger.collapseTarget.addEventListener("transitionend", e => {
            if (e.propertyName === "height" && trigger.collapseTarget.classList.contains("is-active")) {
                trigger.collapseTarget.style.height = "auto";
            }
        });
    });
    function toggle(trigger) {
        if (trigger.collapseTarget.classList.contains("is-active")) {
            close(trigger);
            activeToggle = null;
        } else {
            if (activeToggle && activeToggle.collapseTarget.dataset.parent) {
                close(activeToggle);
            }
            activeToggle = trigger;
            open(trigger);
        }
    }
    function close(trigger) {
        const content = trigger.collapseTarget;
        content.style.height = content.scrollHeight + "px";
        requestAnimationFrame(() => {
            content.style.height = "0px";
            content.classList.remove("is-active");
        });
        trigger.classList.remove("is-active");
    }
    function open(trigger) {
        const content = trigger.collapseTarget;
        content.style.height = "0px"; // reset
        content.classList.add("is-active");
        trigger.classList.add("is-active");
        requestAnimationFrame(() => {
            content.style.height = content.scrollHeight + "px";
        });
    }
})();


const ourRangeSlider = new Swiper('.our-range-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: '.our-range-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.our-range-button-next',
    prevEl: '.our-range-button-prev',
  },
  breakpoints: {
    650: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

const blogCarouselSlider = new Swiper('.blog-carousel-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: false,
  pagination: {
    el: '.bcs-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.bcs-button-next',
    prevEl: '.bcs-button-prev',
  },
  breakpoints: {
    650: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

const orderResultslider = new Swiper('.for_table_slider', {
  loop: false,
  autoHeight: true,
  spaceBetween: 0,
  slidesPerView: 2.25,   
  navigation: {
    nextEl: '.for-button-next',
    prevEl: '.for-button-prev',
  },
  breakpoints: {
    750: {
      slidesPerView: 3,  
    },
  },
});

// stepswiper

const stepSwiper = new Swiper('.stepswiper', {
  loop: true,
  slidesPerView: 1,        // BASE (mobile-first)
  spaceBetween: 20,

  navigation: {
    nextEl: '.step-button-next',
    prevEl: '.step-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },

  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    750: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});


const cppSwiper = new Swiper('.cpp-slider', {
  loop: false,
  spaceBetween: 20,
  slidesPerView: 1,   
  pagination: {
    el: ".cpp-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 2,  
      spaceBetween: 30,
    },
    991: {
      slidesPerView: 3,  
      spaceBetween: 40,
    },
  },
});


// expoer review sldier 
const reviewSlider = new Swiper('.review-slider', {
  loop: true,
  autoHeight: true,
  slidesPerView: 1,  
  navigation: {
    nextEl: '.reviewSlider-button-next',
    prevEl: '.reviewSlider-button-prev',
  },
  pagination: {
    el: ".reviewSlider-pagination",
    type: "fraction",
  },
});


const featuredTestimonialsSlider = new Swiper('.featured-testimonials-slider', {
  loop: false,
  spaceBetween: 20,
  slidesPerView: 1,  
  navigation: {
    nextEl: '.fts-button-next',
    prevEl: '.fts-button-prev',
  },
  pagination: {
    el: ".fts-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
  spaceBetween: 20,
    },
    991: {
      slidesPerView: 3,
  spaceBetween: 20,
    },
  },
});


document.addEventListener("DOMContentLoaded", function () {
  const footerBlocks = document.querySelectorAll(".footer-block");

  const updateAccordionBehavior = () => {
    const isMobile = window.matchMedia("(max-width: 991.98px)").matches;
    footerBlocks.forEach((block) => {
      const heading = block.querySelector("h2");
      const detailsContent = block.querySelector("ul");
      if (heading && detailsContent) {
        if (isMobile) {
          detailsContent.classList.add("hidden");
          if (!heading.classList.contains("accordion-enabled")) {
            heading.classList.add("accordion-enabled");
            heading.addEventListener("click", toggleAccordion);
          }
        } else {
          detailsContent.classList.remove("hidden", "visible");
          heading.classList.remove("active", "accordion-enabled");
          heading.removeEventListener("click", toggleAccordion);
        }
      }
    });
  };
  const toggleAccordion = function () {
    const detailsContent = this.nextElementSibling;
    if (detailsContent) {
      const isOpen = detailsContent.classList.contains("hidden");
      detailsContent.classList.toggle("hidden", !isOpen);
      detailsContent.classList.toggle("visible", isOpen);
      this.classList.toggle("active", isOpen);
    }
  };
  updateAccordionBehavior();
  window.addEventListener("resize", updateAccordionBehavior);
});

$(document).ready(function() {

  function lockScroll() {
    $('body').addClass('no-scroll');
  }

  function unlockScroll() {
    $('body').removeClass('no-scroll');
  }

  $('.popup-video').each(function() {
    const url = $(this).attr('href');

    // YouTube / Vimeo
    if (url.includes('youtube.com') || url.includes('youtu.be') || url.includes('vimeo.com')) {

      $(this).magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,

        callbacks: {
          open: lockScroll,
          close: unlockScroll
        }
      });

    } else {
      // Uploaded video (.mp4 / .mov)
      $(this).magnificPopup({
        type: 'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 160,
        fixedContentPos: false,
        items: {
          src: '#video-popup'
        },
        callbacks: {
          open: function() {
            lockScroll();

            const videoEl = $('#popup-video-element').get(0);
            const videoSrc = this.st.el.data('video');
            $(videoEl).find('source').attr('src', videoSrc);
            videoEl.load();
            videoEl.play();
          },
          close: function() {
            const videoEl = $('#popup-video-element').get(0);
            videoEl.pause();
            videoEl.currentTime = 0;

            unlockScroll();
          }
        }
      });
    }
  });

});


// =====================================================
// FEEDING GUIDE MODAL – SCRIPT (REPLACEMENT)
// - Opens/closes modal
// - Sets default feeding calculator tab by matching button text
// - Resets modal content state on close (tabs + accordions)
// =====================================================
(function () {
  const MODAL_ID = "guidModal";
  const OPEN_CLASS = "show";
  const SCROLL_LOCK = "guid-modal-open";

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function normalize(val) {
    return (val || "").toString().trim().toLowerCase();
  }

  function forceActivateFeedingTab(container, tabBtn) {
    if (!container || !tabBtn) return false;
    const targetId = tabBtn.getAttribute("data-target");
    if (!targetId) return false;

    container.querySelectorAll(".feeding-calculator-tab[data-target]").forEach((btn) => {
      btn.classList.toggle("active", btn === tabBtn);
    });

    container.querySelectorAll('.tab-content[id^="calculator_tab_"]').forEach((panel) => {
      panel.classList.toggle("active", panel.id === targetId);
    });

    return true;
  }

  // -----------------------------
  // RESET STATE (tabs + accordions)
  // -----------------------------
  function resetFeedingCalculator(modal) {
    if (!modal) return;

    const container = modal.querySelector(".feeding-calculator-container");
    if (!container) return;

    // Reset tabs to first tab + first panel
    const tabs = Array.from(
      container.querySelectorAll(".feeding-calculator-tabs .feeding-calculator-tab[data-target]")
    );
    const panels = Array.from(container.querySelectorAll('.tab-content[id^="calculator_tab_"]'));

    if (tabs.length) {
      const firstTab = tabs[0];
      forceActivateFeedingTab(container, firstTab);
    } else if (panels.length) {
      // Safety: if no buttons for some reason, ensure only first panel active
      panels.forEach((p, i) => p.classList.toggle("active", i === 0));
    }

    // Reset accordions inside ALL tab panels
    container.querySelectorAll(".accordion-block .acc-toggle.is-active").forEach((t) => {
      t.classList.remove("is-active");
    });
    container.querySelectorAll(".accordion-block .inner.is-active").forEach((p) => {
      p.classList.remove("is-active");
    });

    // Open first accordion item for each panel (optional but matches your current default)
    container.querySelectorAll('.tab-content[id^="calculator_tab_"]').forEach((panel) => {
      const firstToggle = panel.querySelector(".accordion-block .acc-toggle");
      const firstInner = panel.querySelector(".accordion-block .inner");
      if (firstToggle && firstInner) {
        firstToggle.classList.add("is-active");
        firstInner.classList.add("is-active");
      }
    });
  }

  function trySetDefaultFeedingTab(modal, desired) {
    if (!modal) return false;

    const key = normalize(desired) === "adult" ? "adult" : "puppy";
    const container = modal.querySelector(".feeding-calculator-container");
    if (!container) return false;

    const tabs = Array.from(
      container.querySelectorAll(".feeding-calculator-tabs .feeding-calculator-tab[data-target]")
    );
    if (!tabs.length) return false;

    const match =
      tabs.find((b) => normalize(b.textContent) === key) ||
      tabs.find((b) => normalize(b.textContent).includes(key));

    if (!match) return false;

    // Let any existing handlers run
    try {
      match.click();
    } catch (e) {
      /* ignore */
    }

    // Guarantee correct state
    forceActivateFeedingTab(container, match);

    return true;
  }

  function setDefaultFeedingTabWithRetry(modal, desired) {
    let attempts = 0;
    const maxAttempts = 60; // ~1s

    function tick() {
      attempts += 1;
      const ok = trySetDefaultFeedingTab(modal, desired);
      if (ok || attempts >= maxAttempts) return;
      requestAnimationFrame(tick);
    }

    tick();
  }

  // -----------------------------
  // OPEN MODAL
  // -----------------------------
  window.openGuidModal = function (triggerEl) {
    const modal = getModal();
    if (!modal || modal.classList.contains(OPEN_CLASS)) return;

    modal.classList.add(OPEN_CLASS);
    modal.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add(SCROLL_LOCK);
    document.body.classList.add(SCROLL_LOCK);

    // ✅ Always reset FIRST, then apply requested default
    resetFeedingCalculator(modal);

    const defaultTab =
      (triggerEl && triggerEl.getAttribute && triggerEl.getAttribute("data-default-tab")) || "puppy";

    setDefaultFeedingTabWithRetry(modal, defaultTab);

    const wrapper = modal.querySelector(".guid-modal-wrapper");
    if (wrapper) wrapper.focus();

    window.addEventListener("keydown", onEscClose);
  };

  // -----------------------------
  // CLOSE MODAL
  // -----------------------------
  window.closeGuidModal = function () {
    const modal = getModal();
    if (!modal || !modal.classList.contains(OPEN_CLASS)) return;

    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove(SCROLL_LOCK);
    document.body.classList.remove(SCROLL_LOCK);

    window.removeEventListener("keydown", onEscClose);

    // ✅ Reset after close so next open starts clean
    resetFeedingCalculator(modal);
  };

  function onEscClose(e) {
    if (e.key === "Escape") window.closeGuidModal();
  }
})();
